module.exports = __webpack_public_path__ + "static/media/project3.8bdec235.jpg";